import React from "react";

interface EmailNoticeProps {
  children: React.ReactNode;
}

/**
 * Informational note placed under buttons whose action sends email,
 * saying which template will go out. The system is only used a couple of
 * times a year, so these act as reminders of behaviour that's easy to forget.
 */
function EmailNotice({ children }: EmailNoticeProps) {
  return (
    <div className="sl-email-notice" role="note">
      <span className="sl-email-icon" aria-hidden="true">
        ✉
      </span>
      <span>{children}</span>
    </div>
  );
}

export default EmailNotice;
